import * as React from "react";
import type { SVGProps } from "react";
const SvgProjectPlanPen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10 8H7M3 18.5v-13A2.5 2.5 0 0 1 5.5 3H6a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-.5a2.5 2.5 0 0 0 0 5H19a2 2 0 0 0 2-2v-8"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m14.75 12.684-2.18.31a.498.498 0 0 1-.566-.56l.313-2.184a2 2 0 0 1 .565-1.131L18.38 3.62a2.12 2.12 0 0 1 2.998 0v0a2.12 2.12 0 0 1 0 3l-5.497 5.497a2 2 0 0 1-1.132.566"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgProjectPlanPen;
